import { render, staticRenderFns } from "./SolucionesSection.vue?vue&type=template&id=4e989c27&scoped=true"
import script from "./SolucionesSection.vue?vue&type=script&lang=js"
export * from "./SolucionesSection.vue?vue&type=script&lang=js"
import style0 from "./SolucionesSection.vue?vue&type=style&index=0&id=4e989c27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e989c27",
  null
  
)

export default component.exports